export default __webpack_public_path__ + "static/media/ambiance_dashb.c7c225e9.svg";